import { IOdataField } from './IOdataField';

export class OdataFieldDate implements IOdataField {
  private value: Date;

  constructor(value: Date) {
    this.value = value;
  }

  toFieldString() {
    return `${this.value.getUTCFullYear()}-${("00" + (this.value.getUTCMonth() + 1)).slice(-2)}-${("00" + this.value.getUTCDate()).slice(-2)}T${("00" + this.value.getUTCHours()).slice(-2)}:${("00" + this.value.getUTCMinutes()).slice(-2)}:${("00" + this.value.getUTCSeconds()).slice(-2)}.000Z`;
  };
}
